module.exports = __webpack_public_path__ + "img/quality.e0e7e9a9.svg";